import * as jquery from "../other/js/jquery.js";

globalThis.jQuery = jquery;

jQuery.noConflict();
